<div class="dropdown">
  <div class="dropdown-toggle" (click)="toggle()">
    <ng-content select="[dropdownToggle]"></ng-content>
  </div>

  <ul class="dropdown-menu" [ngClass]="alignment === 'left' ? 'alignment-left' : 'alignment-right'" *ngIf="isOpen">
    <li *ngFor="let option of options" (click)="select(option)" [class]="option.color">
      <tabler-icon [name]="option.icon"></tabler-icon>
      <span>{{ option.text }}</span>
    </li>
  </ul>
</div>